import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = 'LightGroccorApiSecretKey12345678';
const ENCRYPTION_IV = 'LightGroccorIV12';

export const decryptPayload = (payload) => {
    try {
        const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY);
        const iv = CryptoJS.enc.Utf8.parse(ENCRYPTION_IV);

        const decrypted = CryptoJS.AES.decrypt(payload, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedString);
    } catch (error) {
        console.error('Failed to decrypt API response', error);
        return null;
    }
};

export const applyEncryptionInterceptor = (axiosInstance) => {
    axiosInstance.interceptors.response.use(
        (response) => {
            if (response.data && response.data.encrypted && response.data.payload) {
                const decryptedData = decryptPayload(response.data.payload);
                if (decryptedData !== null) {
                    response.data = decryptedData;
                }
            }
            return response;
        },
        (error) => {
            if (error.response && error.response.data && error.response.data.encrypted && error.response.data.payload) {
                const decryptedData = decryptPayload(error.response.data.payload);
                if (decryptedData !== null) {
                    error.response.data = decryptedData;
                }
            }
            return Promise.reject(error);
        }
    );
};
